import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export function ActivateCard({ onDone }) {
  const [go, setGo] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/org/go-live").then((r) => setGo(r.data)).catch(() => {}); }, []);

  const activate = async () => {
    setBusy(true);
    try {
      const r = await api.post("/billing/activate", { confirm_live_test: confirm });
      onDone(r.data);
      toast.success("Activated. No charge today. Your next $775 charge is one month from now.");
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not activate"); }
    finally { setBusy(false); }
  };

  if (!go) return null;
  return (
    <Card className="bg-slate-900 border-slate-800 p-6" data-testid="activate-card">
      <h2 className="font-display text-lg font-semibold text-white">Activate service</h2>
      {!go.ready_for_live ? (
        <p className="text-sm text-amber-300 mt-2" data-testid="activate-blocked">
          Texting Pending Approval. Activation unlocks when every <Link to="/app/go-live" className="underline">Go-Live item</Link> passes.
        </p>
      ) : (
        <div className="space-y-4 mt-3">
          <label className="flex gap-3 items-start">
            <Checkbox checked={confirm} onCheckedChange={(c) => setConfirm(!!c)} data-testid="activate-confirm-test" className="mt-0.5" />
            <span className="text-sm text-slate-300">A live test call and text using our own number and approved registration worked correctly.</span>
          </label>
          <Button onClick={activate} disabled={!confirm || busy} data-testid="activate-submit" className="bg-emerald-500 hover:bg-emerald-600 text-slate-900 font-semibold rounded-full">
            Activate service
          </Button>
          <p className="text-xs text-slate-400" data-testid="activate-no-charge">Activating does not charge your card. Your next monthly charge is one month after activation.</p>
        </div>
      )}
    </Card>
  );
}
